//-----------------------|| REPORTS MENU ITEMS ||-----------------------//

export const reports = {
    id: 'reports',
    title: 'Reports',
    type: 'collapse',
    icon: 'IconReportAnalytics',
    children: [
        {
            id: 'reports.client_submission',
            title: 'Client Submission',
            type: 'item',
            url: '/reports/client_submission',
            icon: 'IconFileText',
            breadcrumbs: false
        }
    ]
};
